import React from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';

const SectionList = ({
  className,
  customClassName,
  sections,
  renderItem,
  renderSectionHeader,
  renderHeader,
  renderBottom,
  keyExtractorSection,
  keyExtractorItem,
  renderLoading,
  renderEmpty,
}) => {
  const renderFunction = ({ overrideRender, defaultRender, propsToRender }) => {
    const renderer = overrideRender || defaultRender;
    return renderer && renderer(propsToRender);
  };

  return (
    <section
      className={cx(className, customClassName)}
      data-testid="orders-list"
    >
      {renderHeader && renderHeader()}
      {renderLoading && renderLoading()}
      {renderEmpty && renderEmpty()}
      {!renderLoading && renderHeader && renderHeader()}
      <div className="scrollableSection">
        <div className="list">
          {sections?.map(
            (section) =>
              section?.data?.length > 0 && (
                <div key={keyExtractorSection({ section })}>
                  {renderFunction({
                    overrideRender: section.renderSectionHeader,
                    defaultRender: renderSectionHeader,
                    propsToRender: { section },
                  })}
                  {section.data.map((item, index) => (
                    <div key={keyExtractorItem({ item })}>
                      {renderFunction({
                        overrideRender: section.renderItem,
                        defaultRender: renderItem,
                        propsToRender: { item, isFirst: index === 0 },
                      })}
                    </div>
                  ))}
                </div>
              )
          )}
        </div>
        {renderBottom && renderBottom()}
      </div>
    </section>
  );
};

SectionList.propTypes = {
  className: PropTypes.string,
  customClassName: PropTypes.string,
  sections: PropTypes.array,
  renderItem: PropTypes.func,
  renderSectionHeader: PropTypes.func,
  renderHeader: PropTypes.func,
  renderBottom: PropTypes.func,
  keyExtractorSection: PropTypes.func,
  keyExtractorItem: PropTypes.func,
  renderLoading: PropTypes.func,
  renderEmpty: PropTypes.func,
};

SectionList.defaultProps = {
  sections: [],
};

export default SectionList;
